/* Joeydolls article click tracking (jd article template only).
   Sends custom GA4 events through the site's existing gtag (G-JZ88S0HTVW); falls back to dataLayer for GTM.
   No ecommerce events here (view_item, add_to_cart, purchase stay with Shopify/GA4 as they are now). */
(function () {
  var root = document.querySelector('[data-jd-article]');
  if (!root) return;
  // Contents list: open on desktop, collapsed on phones (less scrolling).
  var toc = root.querySelector('[data-jd-toc]');
  if (toc && window.matchMedia('(min-width: 990px)').matches) toc.open = true;
  var base = {
    article_handle: root.getAttribute('data-jd-article'),
    article_type: root.getAttribute('data-jd-type'),
    blog_handle: root.getAttribute('data-jd-blog')
  };
  function send(name, extra) {
    var p = Object.assign({}, base, extra || {});
    if (typeof window.gtag === 'function') window.gtag('event', name, p);
    else (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, p));
  }
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-jd-evt]');
    if (!a || !root.contains(a)) return;
    send(a.getAttribute('data-jd-evt'), {
      item_id: a.getAttribute('data-jd-item') || '',
      module_position: Number(a.getAttribute('data-jd-pos')) || 0,
      link_url: a.getAttribute('href') || ''
    });
  });
  // Klaviyo embedded forms on this article: count real submissions only.
  var forms = Array.prototype.map.call(root.querySelectorAll('[data-jd-form]'), function (el) { return el.getAttribute('data-jd-form'); });
  if (forms.length) {
    window.addEventListener('klaviyoForms', function (e) {
      var d = e.detail || {};
      if (d.type === 'submit' && forms.indexOf(d.formId) !== -1) send('blog_signup_submit', { item_id: d.formId });
    });
  }
})();
